import React from "react"
import t, { Translation } from "frontend/utils/translations"

export const getUserLogin = () => {
  return window.slideshare_object.user.login
}

const getMultiUploadLayoutCopy = (filesAsArray, uploadedFileCount, publishedFileCount, isIncentivizedUpload) => {
  if (uploadedFileCount > 0 && uploadedFileCount === publishedFileCount) {
    const heading = t("upload.published.heading")

    const privateFiles = filesAsArray.filter((file) => file.privacy !== "public")
    const isAllPrivate = privateFiles.length === filesAsArray.length
    const isAllPublic = privateFiles.length === 0
    const isMixed = !isAllPrivate && !isAllPublic

    if (isIncentivizedUpload) {
      return [heading, ""]
    }

    if (isAllPrivate) {
      return [
        heading,
        <Translation
          string="upload.published.update_private"
          options={{
            count: filesAsArray.length,
            login: getUserLogin(),
          }}
        />,
      ]
    }

    if (isAllPublic) {
      return [heading, t("upload.published.share_prompt", { count: filesAsArray.length })]
    }

    if (isMixed) {
      return [
        heading,
        t("upload.published.share_public_prompt", {
          count: filesAsArray.length - privateFiles.length,
        }),
      ]
    }
  } else if (publishedFileCount > 0) {
    return [
      t("upload.form.progress.heading"),
      t("upload.form.progress.complete_remaining", {
        count: filesAsArray.length - publishedFileCount,
      }),
    ]
  } else if (uploadedFileCount > 0) {
    return [t("upload.form.heading_plural", [filesAsArray.length]), t("upload.form.tip")]
  } else {
    return [t("upload.form.heading_plural", [filesAsArray.length]), t("upload.form.cta")]
  }
}

const getSingleUploadLayoutCopy = (file, isIncentivizedUpload) => {
  if (file.isPublished) {
    const heading = t("upload.published.heading")

    const isPrivate = file.privacy === "onlyme"
    if (isIncentivizedUpload) {
      return [heading, ""]
    } else if (isPrivate) {
      return [
        heading,
        <Translation
          string="upload.published.update_private"
          options={{
            count: 1,
            login: getUserLogin(),
          }}
        />,
        ,
      ]
    } else {
      return [heading, t("upload.published.share_prompt", { count: 1 })]
    }
  } else if (file.isUploaded) {
    return [t("upload.form.heading"), t("upload.form.tip")]
  } else {
    return [t("upload.form.heading"), t("upload.form.cta")]
  }
}

export const getLayoutCopy = (filesAsArray, isIncentivizedUpload = false) => {
  const uploadedFileCount = filesAsArray.filter((file) => file.isUploaded).length
  const publishedFileCount = filesAsArray.filter((file) => file.isPublished).length
  if (filesAsArray.length > 1) {
    return getMultiUploadLayoutCopy(filesAsArray, uploadedFileCount, publishedFileCount, isIncentivizedUpload)
  } else {
    return getSingleUploadLayoutCopy(filesAsArray[0], isIncentivizedUpload)
  }
}
